import React, { useState, useEffect } from "react";
import Table from './Table';
import ReportAcordeon from '../../../Components/ReportAcordeon'
import { 
    listContentTypeProgress
} from "../../../../../services/NexiDigitalAPI";


const TopContentaccess = ({ index, expanded }) => {
    const name = "Tipos de conteúdos com maior progresso"
    const description = "Exibe Tipos de conteúdo com maior progresso.";

    const [loading, setLoading] = useState(false);
    const [dados, setDados] = useState([]);

    const getData = async () => {
        setLoading(true);
        const responseData = await listContentTypeProgress();
        setDados(responseData);
        setLoading(false);
    }

    useEffect(()=>{
        getData();
    },[])

    const result = (
        <Table 
            dados={ dados } 
            loading={ loading }
        />
    );
    
    return (
        <ReportAcordeon
            name={name}
            description={description}
            result={result}
            index={ index }
            expanded={expanded}
        />
        
    )
}

export default TopContentaccess;